var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"donation-feed-widget-frame"},[(_vm.showFeed)?_c('Iframe',[_c('donation-feed',{attrs:{"campaign-id":_vm.finalCampaignId,"campaign-settings":_vm.campaignSettings}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }